import { IS_DEV } from "../common/secrets";
import DefaultPage from "./default";

class RedirectPage extends DefaultPage {
  static instance;

  static init() {
    if (!RedirectPage.instance) {
      RedirectPage.instance = new RedirectPage();
    }
    return RedirectPage.instance;
  }

  constructor() {
    super();
    const aTag = document.querySelector("#tcf-tracker-redirect-to");

    this._timer = null;
    this._redirectCountdown = 1;
    this._redirectCountdownCont = document.querySelector(
      "#tcf-tracker-redirect-countdown"
    );
    this._redirectToUrl = aTag.getAttribute("href");

    this._startup();
  }

  _startup() {
    this._timerTickHandler();
  }

  _timerTickHandler = () => {
    this._redirectCountdown -= 1;

    this._redirectCountdownCont.innerText = `${this._redirectCountdown}s`;

    if (this._redirectCountdown > 0) {
      return this._nextTick(this._timerTickHandler, 1000);
    } else {
      this._redirect();
    }
  };

  _redirect = () => {
    if (!IS_DEV) window.location.href = this._redirectToUrl;
  };

  _nextTick = (fn, time) => {
    clearTimeout(this._timer);
    this._timer = setTimeout(fn, time);
  };
}

export default RedirectPage;
